import { Col, Spinner2 } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import ChurnCard from './ChurnCard';
import MrrSummaryCard from './MrrSummaryCard';
import RenewalsCard from './RenewalsCard';
import PaymentMethodCard from './PaymentMethodCard';
import SubscriberCountKPI from './SubscriberCountKPI';

const Overview = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOverview();
  }, []);

  async function fetchOverview() {
    setLoading(true);
    const res = await Api.get('/admin/subscriptionPlans/overview');
    if (res?.data) {
      setData(res.data);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <Col wid="100%" marg="80px 0" centerAll noFlex>
        <Spinner2 />
      </Col>
    );
  }

  return (
    <Col start noFlex wid="100%" pad="24px">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        <PaymentMethodCard data={data?.paymentMethods} />
        <MrrSummaryCard data={data?.mrr} />
        <SubscriberCountKPI data={data?.subscriberCount} />
        <ChurnCard />
        <RenewalsCard />
      </div>
    </Col>
  );
};

export default Overview;
